import React from 'react';
import {Input} from '@lightricks/react-design-system';
import DateInputWithPicker from 'src/components/DateInputWithPicker/DateInputWithPicker';
import translate from '@/utils/translate';
import styles from './NameAndBirthdate.module.scss';

type NameAndBirthdateProps = {
  firstNameValue: string;
  lastNameValue: string;
  onChangeFirstName: (firstName: string) => void;
  onChangeLastName: (lastName: string) => void;
  birthdateValue: Date | undefined;
  onChangeBirthdate: (date: Date) => void;
};

function NameAndBirthdate(props: NameAndBirthdateProps) {
  const {
    firstNameValue,
    lastNameValue,
    onChangeFirstName,
    onChangeLastName,
    birthdateValue,
    onChangeBirthdate,
  } = props;

  const handleBirthdateChange = (date: Date | null) => {
    if (date) onChangeBirthdate(date);
  };

  return (
    <div className={styles.nameAndBirthdateContainer}>
      <Input
        placeholder={translate('First name')}
        value={firstNameValue}
        inputProps={{value: firstNameValue}}
        onInputChange={onChangeFirstName}
        className={styles.nameInput}
      />
      <Input
        placeholder={translate('Last name')}
        value={lastNameValue}
        inputProps={{value: lastNameValue}}
        onInputChange={onChangeLastName}
        className={styles.nameInput}
      />
      <DateInputWithPicker
        label=""
        onChange={handleBirthdateChange}
        date={birthdateValue}
        placeholder={translate('Date of birth')}
      />
    </div>
  );
}

export default NameAndBirthdate;
